// extracted by mini-css-extract-plugin
export default {"channelGridContainer":"QUjyD"};